<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h2>检验报告管理系统</h2>
        <p>请登录以继续使用</p>
      </div>
      
      <el-form 
        ref="loginForm" 
        :model="loginData" 
        :rules="rules" 
        class="login-form"
        @submit.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginData.username"
            placeholder="请输入用户名"
            prefix-icon="User"
            size="large"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="Lock"
            size="large"
            show-password
            @keyup.enter="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            size="large" 
            class="login-button"
            :loading="loading"
            @click="handleLogin"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      
      <!-- <div class="login-tips">
        <p>默认账号：Anjieguoji251010</p>
        <p>默认密码：ajgj1010</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const loading = ref(false)
    
    const loginData = reactive({
      username: '',
      password: ''
    })
    
    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
      ]
    }
    
    const loginForm = ref(null)
    
    const handleLogin = async () => {
      if (!loginForm.value) return
      
      try {
        await loginForm.value.validate()
        loading.value = true
        
        // 模拟登录延迟
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        // 静态账号密码验证
        if (loginData.username === 'Anjieguoji251010' && loginData.password === 'ajgj1010') {
          // 保存登录状态到localStorage
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('username', loginData.username)
          localStorage.setItem('loginTime', new Date().toISOString())
          
          ElMessage.success('登录成功！')
          
          // 跳转到报告列表页
          router.push('/ReportList')
        } else {
          ElMessage.error('用户名或密码错误！')
        }
      } catch (error) {
        console.error('登录验证失败:', error)
      } finally {
        loading.value = false
      }
    }
    
    return {
      loginData,
      rules,
      loading,
      loginForm,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    linear-gradient(135deg, rgba(47, 125, 209, 0.08) 0 25%, transparent 25% 100%),
    linear-gradient(315deg, rgba(21, 154, 124, 0.08) 0 20%, transparent 20% 100%),
    linear-gradient(180deg, #f8fafc 0%, #eef3f7 100%);
}

.login-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.11) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.11) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.55), transparent 72%);
  animation: loginGridDrift 18s linear infinite;
  will-change: background-position;
  pointer-events: none;
}

.login-container::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(115deg, transparent 0%, rgba(47, 125, 209, 0.12) 42%, transparent 55%),
    linear-gradient(245deg, transparent 0%, rgba(21, 154, 124, 0.1) 48%, transparent 62%);
  opacity: 0.7;
  animation: loginLightSweep 7s ease-in-out infinite alternate;
  pointer-events: none;
}

.login-card {
  position: relative;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  max-width: 420px;
  padding: 42px 40px 38px;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(14px);
  animation: loginCardIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2f7dd1, #159a7c, #7c3aed, #2f7dd1);
  background-size: 240% 100%;
  animation: loginAccentFlow 5s linear infinite;
}

.login-card::after {
  content: "";
  position: absolute;
  top: -1px;
  left: -40%;
  width: 35%;
  height: calc(100% + 2px);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.42), transparent);
  transform: skewX(-18deg);
  animation: loginCardSheen 4.8s ease-in-out infinite;
  pointer-events: none;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0;
}

.login-header p {
  color: #64748b;
  font-size: 14px;
  margin: 0;
}

.login-form {
  margin-bottom: 0;
}

.login-form .el-form-item {
  margin-bottom: 18px;
}

:deep(.el-input__wrapper) {
  min-height: 46px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 0 0 1px #d9e1ec inset;
  transition: box-shadow 0.2s, background-color 0.2s;
}

:deep(.el-input__inner) {
  color: #172033;
  font-weight: 500;
}

:deep(.el-input__prefix) {
  color: #64748b;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #b8c4d6 inset;
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #2f7dd1 inset, 0 0 0 3px rgba(47, 125, 209, 0.12);
}

.login-button {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 8px;
  background: #2f7dd1;
  box-shadow: 0 12px 24px rgba(47, 125, 209, 0.24);
  font-size: 15px;
  font-weight: 700;
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
}

.login-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.35) 45%, transparent 60%);
  transform: translateX(-120%);
}

.login-button:hover {
  background: #256fbf;
  box-shadow: 0 14px 28px rgba(47, 125, 209, 0.28);
  transform: translateY(-1px);
}

.login-button:hover::before {
  animation: loginButtonSheen 0.75s ease;
}

.login-button:active {
  transform: translateY(0);
}

.login-tips {
  background: #f8fafc;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  border: 1px solid #e5eaf2;
}

.login-tips p {
  margin: 5px 0;
  font-size: 13px;
  color: #64748b;
}

@keyframes loginGridDrift {
  from {
    background-position: 0 0, 0 0;
  }
  to {
    background-position: 42px 42px, 42px 42px;
  }
}

@keyframes loginLightSweep {
  from {
    transform: translateX(-2%);
    opacity: 0.45;
  }
  to {
    transform: translateX(2%);
    opacity: 0.85;
  }
}

@keyframes loginCardIn {
  from {
    transform: translateY(18px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes loginAccentFlow {
  from {
    background-position: 0% 50%;
  }
  to {
    background-position: 240% 50%;
  }
}

@keyframes loginCardSheen {
  0%, 48% {
    transform: translateX(0) skewX(-18deg);
    opacity: 0;
  }
  58% {
    opacity: 1;
  }
  74%, 100% {
    transform: translateX(430%) skewX(-18deg);
    opacity: 0;
  }
}

@keyframes loginButtonSheen {
  from {
    transform: translateX(-120%);
  }
  to {
    transform: translateX(120%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .login-container::before,
  .login-container::after,
  .login-card,
  .login-card::before,
  .login-card::after,
  .login-button:hover::before {
    animation: none;
  }
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    padding: 14px;
  }
  
  .login-card {
    padding: 34px 22px 28px;
  }
  
  .login-header h2 {
    font-size: 20px;
  }
}
</style>
